













































import { Component, mixins, Prop } from 'nuxt-property-decorator'
import '~/assets/scss/v-tooltip.scss'
import { filterUrl } from '~/assets/filters/url'
import { PRODUCTS_API } from '~/assets/config/api-path'
import { IProductAvailabilityStoresItem } from '~/assets/interfaces/products'
import { filterPhone } from '~/assets/filters/phone'
import MixinGeneral from '~/assets/mixins/general'
import ComponentCatalogLabels from '~/components/catalog/labels/labels.vue'
import ComponentLoadingDots from '~/components/loading/dots.vue'

@Component({
  components: {
    ComponentLoadingDots,
    ComponentCatalogLabels,
  },
  filters: {
    filterPhone,
  },
})
export default class ComponentProductAvailabilityStores extends mixins(
  MixinGeneral
) {
  @Prop({ type: Number, default: -1 }) readonly productId!: number
  @Prop({ type: String, default: null }) readonly unit!: string | null

  private title = ''
  private items: IProductAvailabilityStoresItem[] = []
  private isShowQuantity = false
  private isLoading = true

  private async created() {
    const response = await this.$axios.$get(
      filterUrl(PRODUCTS_API + '/' + this.productId + '/availability-stores')
    )
    this.title = response.title
    this.items = response.items
    this.isShowQuantity = response.isShowQuantity || false
    this.isLoading = false
    if (this.items.length === 0) {
      this.$emit('hide')
    }
  }

  private filterLabel(quantity: number) {
    let quantityText = ''
    if (quantity) {
      quantityText = 'В наличии'
      if (this.isShowQuantity) {
        quantityText =
          quantityText + ': ' + quantity + ' ' + (this.unit ? this.unit : 'шт')
      }
    } else {
      quantityText = 'Отсутствует'
    }

    const label = {
      text: quantityText,
      color: quantity ? 'success' : 'gray',
    }
    return [label]
  }
}
